module.exports = __webpack_public_path__ + "img/icon-exterior-gray.3caa9b7c.svg";